import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type { UploadFileResponse } from "../types/common.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.common;

export const commonService = {
  async uploadFile(files: File | File[]): Promise<UploadFileResponse> {
    try {
      const formData = new FormData();
      (Array.isArray(files) ? files : [files]).forEach((file) =>
        formData.append("files", file),
      );

      return await apiClient<UploadFileResponse>(endpoints.uploadFile, {
        method: "POST",
        body: formData,
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to upload file due to an unexpected error.",
        filesUploaded: [],
      };
    }
  },
};
